import { useMemo } from "react";

import type { ExistingRoomI18nEditQuery } from "@/lib/gql/__generated__/graphql";

import { useInitProductRoomI18nFormModelContext } from "../../../init";
import { serverModelToInputModelConverter } from "./converter/server-model-to-input-mode/server-model-to-input-mode";
import { useRoomI18nEditMutation } from "../../../repository/existing/mutation/use-room-i18n-edit-mutation";

import type { ProductExistingRoomI18nFormModelContextType } from "../../../../ui/existing/context/context";

type Props = {
	serverModel: ExistingRoomI18nEditQuery;
};

export const useInitialized = ({ serverModel }: Props): ProductExistingRoomI18nFormModelContextType => {
	const inputModel = useMemo(() => serverModelToInputModelConverter(serverModel), [serverModel]);

	const queryData = undefined;

	const { onSetViewModel, viewModel } = useInitProductRoomI18nFormModelContext({ inputModel, queryData });

	const { onUpdateRoom18n: onUpdate } = useRoomI18nEditMutation();

	return {
		queryData,
		onSetViewModel,
		viewModel,
		onUpdate: () => onUpdate({ ...viewModel }),
	};
};
